import {Component, computed, input, signal} from '@angular/core';
import {IconsComponent} from '../icons/icons.component';

type AlertVariant = 'notice' | 'error' | 'success' | 'warning' | 'instruction';

@Component({
  selector: 'app-alert',
  imports: [
    IconsComponent
  ],
  templateUrl: './alert.html',
  styleUrl: './alert.css'
})
export class Alert {
  variant = input<AlertVariant>('notice');
  closable = input<boolean>(false);

  isVisible = signal(true);

  alertClasses = computed(() => {
    const baseClasses = 'flex sm:items-center p-4 mb-4 text-sm rounded-base transition-opacity duration-300 mx-auto max-w-2xl';

    const variantClasses: Record<AlertVariant, string> = {
      notice: 'text-blue-800 bg-blue-50',
      error: 'text-fg-danger-strong bg-danger-soft',
      success: 'text-fg-success-strong bg-success-soft',
      warning: 'text-fg-warning bg-warning-soft',
      instruction: 'text-purple-800 bg-purple-50'
    };

    return `${baseClasses} ${variantClasses[this.variant()]}`;
  });

  buttonClasses = computed(() => {
    const baseClasses = 'ms-auto -mx-1.5 -my-1.5 rounded focus:ring-2 p-1.5 inline-flex items-center justify-center h-8 w-8 shrink-0';

    const variantClasses: Record<AlertVariant, string> = {
      notice: 'focus:ring-blue-400 hover:bg-blue-100',
      error: 'bg-danger-soft text-fg-danger-strong focus:ring-danger-medium hover:bg-danger-medium',
      success: 'focus:ring-success-medium hover:bg-success-medium',
      warning: 'focus:ring-warning-medium hover:bg-warning-medium',
      instruction: 'focus:ring-purple-400 hover:bg-purple-100'
    };

    return `${baseClasses} ${variantClasses[this.variant()]}`;
  });

  defaultIcon = computed(() => {
    const icons: Record<AlertVariant, string> = {
      notice: 'info-circle',
      error: 'do-not-enter',
      success: 'circle-check',
      warning: 'circle-exclamation',
      instruction: 'question-circle'
    };

    return icons[this.variant()];
  });

  close() {
    this.isVisible.set(false);
    // Remove from DOM after animation completes
    setTimeout(() => {
      // Component will be hidden by @if
    }, 300);
  }
}
